import translatePage from './src/translatePage';
import useTranslation from './src/useTranslation';

export { translatePage };
export { useTranslation };
